import { Link } from 'react-router-dom';
import { useMatch } from 'react-router';
import React from 'react';

type Props = {
  children: any;
  className?: string;
};

export const Sidebar = (props: Props): JSX.Element => {
  return <div className={`sidebar ${props.className || ''}`}>{props.children}</div>;
};

type LinkProps = {
  to: string;
  children: string;
};

export const SidebarLink = (props: LinkProps): JSX.Element => {
  const match = useMatch(props.to);
  return <Link to={props.to} className={`sidebar-link ${match ? 'active' : ''}`}>{props.children}</Link>;
};
